import {FC, ReactNode} from 'react'
import {Navigate} from 'react-router-dom'
import {useAuth} from '../modules/auth'
import {ONLINE_REGISTRATION_PATH, hasNoBusiness} from '../modules/auth/core/onlineRegistration'

/**
 * The panel's pages are a business's pages. A person signed in without a business goes to the registration page from
 * any address (the user, 2026-10-31); PrivateRoutes has already asked for the mobile, name and password by then. Staff
 * and support sessions always carry a role, so this never stops them.
 */
export const BusinessRequired: FC<{children: ReactNode}> = ({children}) => {
  const {currentUser} = useAuth()
  if (hasNoBusiness(currentUser)) return <Navigate to={ONLINE_REGISTRATION_PATH} replace />
  return <>{children}</>
}
